import { LegType } from '../models/leg-type';
import { StepValues } from '../models/step-values';
import { BraSize } from './bra-helper';

export const getOptionsFromStepValues = (stepValues: StepValues) => {
  const waistOption = stepValues.get('waist-measurement');
  const hipOption = stepValues.get('hip-measurement');
  const dressOption = stepValues.get('dress');
  const dressOtherOption = stepValues.get('dress-other');
  const jeansOption = stepValues.get('jeans');
  const shapewearOption = stepValues.get('what-shapewear-fits-well');
  const legTypeOption = stepValues.get('leg-type');

  const braOption = stepValues.get('bra');
  const braAdditionalOption = stepValues.get('bra-additional');
  const hookOption = stepValues.get('hook');
  const fittedTopsOption = stepValues.get('fitted-tops');
  const fittedShirtsOption = stepValues.get('fitted-shirts');
  const kindOfFitOption = stepValues.get('kind-of-fit');

  const cupFitOption = stepValues.get('cup-fit');
  const bandFitOption = stepValues.get('band-fit');
  const tankFitOption = stepValues.get('tank-fit');
  const pantsOption = stepValues.get('pants');
  const heightOption = stepValues.get('height');
  const measureFromMemoryOption = stepValues.get('measure-from-memory');

  const waist = waistOption?.imperialText ? parseInt(waistOption.imperialText.replace(/\D/g, ''), 10) || undefined : undefined;
  const hips = hipOption?.imperialText ? parseInt(hipOption.imperialText.replace(/\D/g, ''), 10) || undefined : undefined;
  const dress = dressOption?.text ? parseInt(dressOption.text.replace(/\D/g, ''), 10) || undefined : undefined;
  const dressOther = dressOtherOption?.text ? parseInt(dressOtherOption.text.replace(/\D/g, ''), 10) || undefined : undefined;
  const jeans = jeansOption?.text ? parseInt(jeansOption.text.replace(/\D/g, ''), 10) || undefined : undefined;
  const shapewear = shapewearOption?.text ? shapewearOption.text : undefined;
  const pants = pantsOption?.text ? parseInt(pantsOption.text.replace(/\D/g, ''), 10) || undefined : undefined;
  const legType: LegType = legTypeOption?.value as LegType;

  const bra: BraSize = braOption?.text as BraSize;
  const braAdditional: BraSize = braAdditionalOption?.text as BraSize;
  const hook = hookOption?.text ?? undefined;
  const fittedTops = fittedTopsOption?.text ?? undefined;
  const fittedShirts = fittedShirtsOption?.text ?? undefined;
  const kindOfFit = kindOfFitOption?.text ?? undefined;
  const cupFit = cupFitOption?.text;
  const bandFit = bandFitOption?.text;
  const height = heightOption?.metricText; // Easier to work with metric over imperial

  const tankFit = tankFitOption?.text;
  const measureFromMemory = measureFromMemoryOption?.text === "I'm going off of memory";

  return {
    bra,
    braAdditional,
    waist,
    hips,
    dress,
    dressOther,
    jeans,
    shapewear,
    pants,
    hook,
    fittedTops,
    fittedShirts,
    kindOfFit,
    cupFit,
    bandFit,
    tankFit,
    height,
    measureFromMemory,
    legType,
  };
};
